import * as React from 'react';

import { TagModel } from '@notino/react-styleguide';
import { IStock } from '@notino/shared/definitions/custom-definitions';

import { useTagAttributes } from '@components/Universals/ProductItem/useTagAttributes';
import { useNewPdDesignEnabled } from '@containers/ProductDetailContainer/ProductDetail/hooks/useNewPdDesignEnabled';

import { FormattedTooltip } from './FormattedTooltip';
import { ITagsProps } from './model';
import { StyledTag, StyledTagWrapper } from './styled';

export const Tags: React.FC<ITagsProps> = ({
  type = TagModel.Types.default,
  onClick,
  nowrapLg = false,
  ...props
}) => {
  const newDesign = useNewPdDesignEnabled();
  const tagAttributes = useTagAttributes(props.attributes, {
    multiple: props?.multiple,
  });
  if (props.stockAvailability === IStock.outOfStock || !tagAttributes) {
    return null;
  }

  const size = props.small ? TagModel.Sizes.small : TagModel.Sizes.default;

  return (
    <StyledTagWrapper nowrapLg={nowrapLg}>
      {tagAttributes.map(
        ({ style, icon, tooltipMessage, label, attribute }) => (
          <FormattedTooltip
            key={label}
            wrapperEnabled={
              !props.small &&
              type === TagModel.Types.default &&
              !!tooltipMessage
            }
            tooltipMessage={tooltipMessage}
          >
            <StyledTag
              newDesign={newDesign}
              onClick={() => onClick?.(attribute)}
              key={label}
              tagStyle={style}
              icon={icon}
              tagType={type}
              tagSize={size}
              className={`pd-variant-tag-${label}`}
            >
              {label}
            </StyledTag>
          </FormattedTooltip>
        )
      )}
    </StyledTagWrapper>
  );
};
